export const POKEMON_PATH = '/pokemon'
